<template>
  <Layout>
    <PageHeader
      :title="title"
      :items="items"
      :backButton="true"
      :prevRoutePath="backUrl"
    />

    <!-- Person details & top mention -->
    <div class="row">
      <div class="col-lg-6 col-sm-6">
        <div class="card h-100">
          <div class="card-body text-left">
            <div class="row">
              <div class="col-sm-4">
                <h5>{{ $t("twitter.basic-info") }}</h5>
              </div>
              <div class="col-sm-8 text-right text-secondary">
                <router-link
                  :to="'/report-twitter/' + id"
                  target="_blank"
                  class="mr-1"
                >
                  <b-button class="btn btn-sm text-secondary" variant="light"
                    ><i class="mdi mdi-badge-account-horizontal-outline"></i>
                    {{ $t("twitter.report") }} Twitter</b-button
                  >
                </router-link>
                <router-link
                  :to="'/twitter/report-view/' + id"
                  target="_blank"
                  class="mr-1"
                >
                  <b-button class="btn btn-sm text-secondary" variant="light"
                    ><i class="mdi mdi-account-star"></i>
                    Engagement</b-button
                  >
                </router-link>
                <b-button
                  class="btn btn-sm mr-1"
                  variant="success"
                  @click="updateAll"
                >
                  <span v-if="loadingupdate"
                    ><b-spinner
                      label="Loading ..."
                      small
                      class="p-0 mb-1"
                      style="width: 0.6rem; height: 0.6rem"
                    ></b-spinner>
                    Loading..</span
                  >
                  <span v-if="!loadingupdate"
                    ><i class="bx bx-history"></i>
                    {{ $t("twitter.update-all") }}
                  </span></b-button
                >
              </div>
            </div>
            <div class="mb-3 mt-4">
              <div class="media">
                <img
                  :src="
                    basicInfo.avatar != ''
                      ? basicInfo.avatar
                      : 'https://img.icons8.com/ios/240/000000/user-male-circle.png'
                  "
                  class="mr-3 rounded-circle avatar-md"
                  alt="user-pic"
                />
                <div class="media-body p-1 text-center">
                  <h6 class="mb-1">{{ $t("twitter.tweets") }}</h6>
                  <hr />
                  <h6>{{ basicInfo.tweets }}</h6>
                </div>
                <div class="media-body p-1 text-center">
                  <h6 class="mb-1">{{ $t("twitter.favorites") }}</h6>
                  <hr />
                  <h6>{{ basicInfo.favorites }}</h6>
                </div>
                <div class="media-body p-1 text-center">
                  <h6 class="mb-1">{{ $t("twitter.followers") }}</h6>
                  <hr />
                  <h6>{{ basicInfo.followers }}</h6>
                </div>
                <div class="media-body p-1 text-center">
                  <h6 class="mb-1">{{ $t("twitter.following") }}</h6>
                  <hr />
                  <h6>{{ basicInfo.following }}</h6>
                </div>
              </div>
            </div>
            <div>
              <a
                :href="'https://twitter.com/' + basicInfo.username"
                target="_blank"
                ><p class="text-primary">
                  {{ basicInfo.name }}
                  <span v-if="basicInfo.verified == 1"
                    ><i
                      class="my-auto ml-1 text-primary mdi mdi-check-decagram mdi-18px"
                    ></i
                  ></span>
                  &nbsp;
                  <span
                    v-if="basicInfo.private == 1"
                    class="text-secondary align-items-center"
                  >
                    <i
                      class="text-dark mdi mdi-shield-lock-outline mdi-24px"
                    ></i>
                    {{ $t("twitter.account-private") }}
                  </span>
                </p></a
              >
              <a
                :href="'https://twitter.com/' + basicInfo.username"
                target="_blank"
                ><p class="text-secondary">@{{ basicInfo.username }}</p>
              </a>
              <p>Bio</p>
              <p>{{ basicInfo.bio }}</p>
              <p v-if="basicInfo.location">
                <i class="bx bx-map"> </i> {{ basicInfo.location }}
              </p>
              <p>
                <i class="bx bx-calendar"> </i>
                {{ $t("twitter.table.joint-at") }}: {{ basicInfo.join_date }}
              </p>
              <p>
                <i class="bx bx-calendar"> </i> {{ $t("twitter.updated") }}:
                {{ formatDateRefresh(basicInfo.updated_at) }}
              </p>
            </div>
          </div>
        </div>
      </div>

      <div class="col-lg-6 col-sm-6">
        <div class="card" style="height: 570px">
          <div class="card-body text-left">
            <div class="row">
              <div class="col-sm-6">
                <h5>{{ $t("twitter.twitter-view.top-mention") }}</h5>
              </div>
              <div class="col-sm-6 text-right">
                <span
                  class="text-secondary btn btn-sm btn-light mr-1"
                  v-if="created_at_topmention"
                >
                  {{ $t("twitter.update") }} :
                  {{ formatDateRefresh(created_at_topmention) }}</span
                >
              </div>
            </div>
            <div class="row pt-4">
              <div class="col-sm-12 p-5 mt-5" v-if="loadingtopmention">
                <div class="text-center loading">
                  <b-spinner label="Loading..."></b-spinner>
                </div>
              </div>
              <div
                class="col-sm-12 p-5 mt-5"
                v-if="!loadingtopmention && !topMention[0]"
              >
                <div class="text-center loading">
                  {{ $t("all.dnf") }}
                </div>
              </div>
              <div
                class="table-responsive mb-0"
                v-if="!loadingtopmention && topMention[0]"
              >
                <b-table
                  :items="topMention"
                  :fields="fieldsTopMention"
                  responsive="sm"
                  :sort-by.sync="sortBy"
                  :sort-desc.sync="sortDesc"
                >
                  <template #cell(user_mention)="row">
                    <a
                      :href="'https://twitter.com/' + row.item.user_mention"
                      target="_blank"
                      >{{ row.item.user_mention }}</a
                    >
                  </template>
                  <template #cell(percentage)="row">
                    {{ toFixed(row.item.percentage) }} %
                  </template>
                </b-table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Heatmap tweets by time -->
    <div class="row mt-4">
      <div class="col-lg-12 col-sm-12">
        <div class="card">
          <div class="row">
            <div class="col-sm-6">
              <h5 class="p-4">{{ $t("twitter.twitter-view.heat-map") }}</h5>
            </div>
            <div class="col-sm-6 text-right px-4 pt-4">
              <span
                class="text-secondary btn btn-sm btn-light mr-1"
                v-if="created_at_heatmap"
                >{{ $t("twitter.updated") }}
                {{ formatDateRefresh(created_at_heatmap) }}</span
              >
            </div>
          </div>
          <div class="col-sm-12 p-5 mt-5 mb-5" v-if="loadingheatmap">
            <div class="text-center loading">
              <b-spinner label="Loading..."></b-spinner>
            </div>
          </div>
          <div
            class="col-sm-12 p-5 mt-5 mb-5"
            v-if="!loadingheatmap && !cek_heatmap"
          >
            <div class="text-center loading">
              {{ $t("all.dnf") }}
            </div>
          </div>
          <div class="p-4" v-if="!loadingheatmap && cek_heatmap">
            <apexchart
              type="heatmap"
              height="350"
              :options="{
                chart: {
                  height: 350,
                  type: 'heatmap',
                },
                dataLabels: {
                  enabled: false,
                },
                colors: ['#bf151c'],
                theme: {
                  mode: theme,
                  palette: 'palette1',
                  monochrome: {
                    enabled: false,
                    color: '#bf151c',
                    shadeTo: theme,
                    shadeIntensity: 0.7,
                  },
                },

                title: {
                  text: this.$t('twitter.twitter-view.last-heat-map'),
                  align: 'center',
                },
              }"
              :series="heatmapSeries"
            ></apexchart>
          </div>
        </div>
      </div>
    </div>

    <!-- Followers Following top 5 -->
    <div class="row mt-4">
      <div class="col-lg-6 col-sm-6">
        <div class="card h-100">
          <div class="row">
            <div class="col-sm-6">
              <h5 class="p-4">{{ $t("twitter.twitter-view.following") }}</h5>
            </div>
            <div class="col-sm-6 text-right">
              <h5 class="p-4">Top 5</h5>
            </div>
          </div>
          <div class="col-sm-12 p-5 mt-5 mb-5" v-if="loadingtopfollowing">
            <div class="text-center loading">
              <b-spinner label="Loading..."></b-spinner>
            </div>
          </div>
          <div
            class="col-sm-12 p-5 mt-5 mb-5"
            v-if="!loadingtopfollowing && !topFollowing[0]"
          >
            <div class="text-center loading">
              {{ $t("all.dnf") }}
            </div>
          </div>

          <div class="pt-0">
            <div class="table-responsive mb-0">
              <b-table
                :items="topFollowing"
                :fields="fieldsTopFollowing"
                responsive="sm"
                :sort-by.sync="sortBy"
                :sort-desc.sync="sortDesc"
              >
                <template #cell(name)="row">
                  <div class="media">
                    <img
                      :src="
                        row.item.profile_image_url_https != ''
                          ? row.item.profile_image_url_https
                          : 'https://img.icons8.com/ios/240/000000/user-male-circle.png'
                      "
                      class="mr-3 rounded-circle avatar-xs"
                      alt="user-pic"
                    />
                    <div class="media-body">
                      <b
                        ><a
                          :href="'https://twitter.com/' + row.item.username"
                          target="_blank"
                          rel="noopener noreferrer"
                          >{{ row.item.name }}</a
                        ></b
                      >
                      <br />
                      <p class="text-secondary">@{{ row.item.username }}</p>
                    </div>
                  </div>
                </template>
              </b-table>
            </div>
          </div>
        </div>
      </div>
      <div class="col-lg-6 col-sm-6">
        <div class="card h-100">
          <div class="row">
            <div class="col-sm-6">
              <h5 class="p-4">{{ $t("twitter.twitter-view.followers") }}</h5>
              <!-- {{tableDataTopFollowers}} -->
            </div>
            <div class="col-sm-6 text-right">
              <h5 class="p-4">Top 5</h5>
            </div>
          </div>
          <div class="col-sm-12 p-5 mt-5 mb-5" v-if="loadingtopfollowers">
            <div class="text-center loading">
              <b-spinner label="Loading..."></b-spinner>
            </div>
          </div>
          <div
            class="col-sm-12 p-5 mt-5 mb-5"
            v-if="!loadingtopfollowers && !topFollowers[0]"
          >
            <div class="text-center loading">
              {{ $t("all.dnf") }}
            </div>
          </div>

          <div class="pt-0" v-if="!loadingtopfollowers && topFollowers[0]">
            <div class="table-responsive mb-0">
              <b-table
                :items="topFollowers"
                :fields="fieldsTopFollowers"
                responsive="sm"
                :sort-by.sync="sortBy"
                :sort-desc.sync="sortDesc"
              >
                <template #cell(name)="row">
                  <div class="media">
                    <img
                      :src="
                        row.item.profile_image_url_https != ''
                          ? row.item.profile_image_url_https
                          : 'https://img.icons8.com/ios/240/000000/user-male-circle.png'
                      "
                      class="mr-3 rounded-circle avatar-xs"
                      alt="user-pic"
                    />
                    <div class="media-body">
                      <b
                        ><a
                          :href="'https://twitter.com/' + row.item.username"
                          target="_blank"
                          rel="noopener noreferrer"
                          >{{ row.item.name }}</a
                        ></b
                      >
                      <br />
                      <p class="text-secondary">@{{ row.item.username }}</p>
                    </div>
                  </div>
                </template>
              </b-table>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Timeline tweets  -->
    <div class="row mt-4 mb-4">
      <div class="col-lg-12 col-sm-12">
        <div class="card">
          <div class="row">
            <div class="col-sm-6">
              <h5 class="pt-4 px-4">
                {{ $t("twitter.twitter-view.timeline") }}
              </h5>
            </div>
            <div class="col-sm-6 text-right pt-4 px-4">
              <span class="text-secondary btn btn-sm btn-light mr-1"
                >{{ $t("twitter.updated") }}
                {{ formatDateRefresh(created_at_timeline) }}</span
              >
              <b-button
                class="btn btn-sm"
                variant="success"
                @click="getUserTimelineTwint"
              >
                <span v-if="loadingupdate"
                  ><b-spinner
                    label="Loading ..."
                    small
                    class="p-0 mb-1"
                    style="width: 0.6rem; height: 0.6rem"
                  ></b-spinner
                ></span>
                <span v-if="!loadingupdate"><i class="bx bx-history"></i></span
              ></b-button>
            </div>
          </div>

          <div class="col-sm-12">
            <div id="map" class="mt-4 px-2">
              <GmapMap
                ref="mymap"
                :center="center"
                :zoom="zoom"
                style="height: 50vh"
              >
                <GmapMarker
                  v-for="(m, index) in location_coor"
                  :key="index"
                  :position="{
                    lat: parseFloat(m.lat),
                    lng: parseFloat(m.long),
                  }"
                  :icon="{
                    url: 'https://img.icons8.com/fluency/35/000000/twitter.png',
                    width: 35,
                    height: 35,
                    anchor: { x: 5, y: 25 },
                  }"
                  @click="openMarker(index)"
                >
                  <gmap-info-window
                    :opened="openedMarkerID === index"
                    @closeclick="openMarker(null)"
                  >
                    <div class="p-2">
                      <h5>Date : {{ formatDate(m.content.date) }}</h5>
                      <p class="mt-2" style="width: 200px">
                        {{ m.content.caption }}
                      </p>
                    </div>
                  </gmap-info-window>
                </GmapMarker>
              </GmapMap>
            </div>
          </div>

          <div class="col-sm-12 p-5 mt-5 mb-5" v-if="loadingtimeline">
            <div class="text-center loading mb-5">
              <b-spinner label="Loading..."></b-spinner>
            </div>
          </div>
          <div
            class="col-sm-12 p-5 mt-5 mb-5"
            v-if="!loadingtimeline && !tableData[0]"
          >
            <div class="text-center loading">
              {{ $t("all.dnf") }}
            </div>
          </div>
          <div class="card-body" v-if="!loadingtimeline && tableData[0]">
            <div class="row mt-0 mb-2">
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    {{ $t("all.show") }}&nbsp;&nbsp;
                    <b-form-select
                      v-model="perPage"
                      size="sm"
                      :options="pageOptions"
                      class="mx-1"
                    ></b-form-select
                    >&nbsp;&nbsp;{{ $t("all.entries") }}
                  </label>
                </div>
              </div>
              <!-- Search -->
              <div class="col-sm-12 col-md-6">
                <div
                  id="tickets-table_filter"
                  class="dataTables_filter text-md-right"
                >
                  <label class="d-inline-flex align-items-center">
                    {{ $t("all.search") }}:
                    <b-form-input
                      v-model="filter"
                      type="search"
                      :placeholder="$t('all.searchh')"
                      class="form-control form-control ml-2"
                    ></b-form-input>
                  </label>
                </div>
              </div>
            </div>

            <!-- Table -->
            <div class="table-responsive mb-0">
              <b-table
                :items="tableData"
                :fields="fieldsTimeline"
                bordered
                responsive="sm"
                :per-page="perPage"
                :current-page="currentPage"
                :sort-by.sync="sortBy"
                :sort-desc.sync="sortDesc"
                :filter="filter"
                :filter-included-fields="filterOn"
              >
                <template #cell(date)="row">
                  <span class="text-secondary"
                    >{{ formatDay(row.item.date) }},</span
                  >
                  <br />
                  <span class="text-secondary">{{
                    formatDate(row.item.date)
                  }}</span>
                </template>
                <template #cell(actions)="row">
                  <a
                    :href="row.item.link"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <b-button
                      class="mr-2 btn-sm"
                      variant="primary"
                      title="Show"
                    >
                      <i class="bx bx-show-alt"></i> </b-button
                  ></a>
                </template>
              </b-table>
            </div>
            <div class="row">
              <div class="col">
                <div
                  class="dataTables_paginate paging_simple_numbers float-right"
                >
                  <ul class="pagination pagination-rounded mb-0">
                    <!-- pagination -->
                    <b-pagination
                      v-model="currentPage"
                      :total-rows="rows"
                      :per-page="perPage"
                    ></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Word Cloud -->
    <div class="row mb-4">
      <div class="col-lg-7 col-sm-7">
        <div class="card h-100">
          <div class="card-body text-left">
            <div class="row">
              <div class="col-sm-6">
                <h5>{{ $t("twitter.twitter-view.word-cloud") }}</h5>
              </div>
              <div class="col-sm-6 text-right">
                <span
                  class="text-secondary btn btn-sm btn-light mr-1"
                  v-if="created_at_topmention"
                  >{{ $t("twitter.updated") }}
                  {{ formatDateRefresh(created_at_topmention) }}</span
                >
              </div>
            </div>
            <div class="col-sm-12 p-5 mt-5 mb-5" v-if="loadingworldcloud">
              <div class="text-center loading">
                <b-spinner label="Loading..."></b-spinner>
              </div>
            </div>
            <div
              class="col-sm-12 p-5 mt-5 mb-5"
              v-if="!loadingworldcloud && !tableDataTopWordCloud[0]"
            >
              <div class="text-center loading">
                {{ $t("all.dnf") }}
              </div>
            </div>
            <div v-if="!loadingworldcloud && wordCloud[0]">
              <div class="text-center p-5">
                <vue-word-cloud
                  style="
                    height: 480px;
                    width: 100%;
                    font-family: arial, sans-serif;
                  "
                  :words="wordCloud"
                  :color="
                    ([, weight]) =>
                      weight > 10
                        ? '#BD241E'
                        : weight > 5
                        ? '#bc0505'
                        : '#f42c2c'
                  "
                  font-family="Poppins, sans-serif"
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="col-lg-5 col-sm-5">
        <div class="card h-100">
          <div class="card-body text-left">
            <h5>{{ $t("twitter.twitter-view.top-word") }}</h5>
            <div class="col-sm-12 p-5 mt-5 mb-5" v-if="loadingworldcloud">
              <div class="text-center loading">
                <b-spinner label="Loading..."></b-spinner>
              </div>
            </div>
            <div
              class="col-sm-12 p-5 mt-5 mb-5"
              v-if="!loadingworldcloud && !tableDataTopWordCloud[0]"
            >
              <div class="text-center loading">
                {{ $t("all.dnf") }}
              </div>
            </div>
            <div
              class="pt-4"
              v-if="!loadingworldcloud && tableDataTopWordCloud[0]"
            >
              <div class="table-responsive mb-0">
                <b-table
                  :items="tableDataTopWordCloud.slice(0, 10)"
                  :fields="fieldsTopWordCloud"
                  responsive="sm"
                  :sort-by.sync="sortBy"
                  :sort-desc.sync="sortDesc"
                >
                </b-table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Hastag Cloud -->
    <div class="row mb-4">
      <div class="col-lg-7 col-sm-7">
        <div class="card h-100">
          <div class="card-body text-left">
            <div class="row">
              <div class="col-sm-6">
                <h5>{{ $t("twitter.twitter-view.hastag-cloud") }}</h5>
              </div>
              <div class="col-sm-6 text-right">
                <span
                  class="text-secondary btn btn-sm btn-light mr-1"
                  v-if="created_at_hastagcloud"
                  >{{ $t("twitter.updated") }}
                  {{ formatDateRefresh(created_at_hastagcloud) }}</span
                >
              </div>
            </div>
            <div>
              <div class="col-sm-12 p-5 mt-5 mb-5" v-if="loadinghastag">
                <div class="text-center loading">
                  <b-spinner label="Loading..."></b-spinner>
                </div>
              </div>
              <div
                class="col-sm-12 p-5 mt-5 mb-5"
                v-if="!loadinghastag && !hastagsCloud[0]"
              >
                <div class="text-center loading">
                  {{ $t("all.dnf") }}
                </div>
              </div>
              <div
                class="text-center p-5"
                v-if="!loadinghastag && hastagsCloud[0]"
              >
                <vue-word-cloud
                  style="
                    height: 480px;
                    width: 100%;
                    font-family: arial, sans-serif;
                  "
                  :words="hastagsCloud"
                  :color="
                    ([, weight]) =>
                      weight > 25
                        ? '#BD241E'
                        : weight > 15
                        ? '#bc0505'
                        : '#d10404'
                  "
                  font-family="Poppins, sans-serif"
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="col-lg-5 col-sm-5">
        <div class="card h-100">
          <div class="card-body text-left">
            <h5>{{ $t("twitter.twitter-view.top-hastag") }}</h5>

            <div class="col-sm-12 p-5 mt-5 mb-5" v-if="loadinghastag">
              <div class="text-center loading">
                <b-spinner label="Loading..."></b-spinner>
              </div>
            </div>
            <div
              class="col-sm-12 p-5 mt-5 mb-5"
              v-if="!loadinghastag && !hastagsCloud[0]"
            >
              <div class="text-center loading">
                {{ $t("all.dnf") }}
              </div>
            </div>
            <div
              class="table-responsive mb-0"
              v-if="!loadinghastag && tableDataTopHastag[0]"
            >
              <b-table
                :items="tableDataTopHastag.slice(0, 10)"
                :fields="fieldsTopHastag"
                responsive="sm"
                :sort-by.sync="sortBy"
                :sort-desc.sync="sortDesc"
              >
              </b-table>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Pie sentimen analys twet by -->
    <div class="row mb-4">
      <div class="col-lg-6 col-sm-6">
        <div class="card h-100">
          <div class="card-body text-left">
            <div class="row">
              <div class="col-sm-6">
                <h5>{{ $t("twitter.twitter-view.sentimen") }}</h5>
              </div>
              <div class="col-sm-6 text-right">
                <span
                  class="text-secondary btn btn-sm btn-light mr-1"
                  v-if="created_at_sentiment"
                  >{{ $t("twitter.updated") }}
                  {{ formatDateRefresh(created_at_sentiment) }}</span
                >
              </div>
            </div>
            <div class="col-sm-12 mb-3 mt-5 text-center">
              <h6 v-if="!loadingsentiment && label_sentiment[0]">
                <b>{{ $t("twitter.twitter-view.sentimen-analys") }}</b>
              </h6>
              <p
                v-if="!loadingsentiment && label_sentiment[0]"
                class="text-secondary"
              >
                ({{ $t("twitter.twitter-view.last-from-200") }})
              </p>
              <div class="col-sm-12 p-5 mt-5" v-if="loadingsentiment">
                <div class="text-center loading">
                  <b-spinner label="Loading..."></b-spinner>
                </div>
              </div>
              <div
                class="col-sm-12 p-5 mt-5"
                v-if="!loadingsentiment && !label_sentiment[0]"
              >
                <div class="text-center loading">
                  <span class="text-secondary"> {{ $t("all.dnf") }}</span>
                </div>
              </div>
              <div v-if="!loadingsentiment && label_sentiment[0]">
                <apexchart
                  class="apex-charts"
                  dir="ltr"
                  height="340"
                  :series="sentimenOptions.series"
                  :options="{
                    chart: {
                      type: 'pie',
                      height: 340,
                      size: 250,
                    },
                    labels: label_sentiment,
                    colors: colors_sentiment,
                    legend: {
                      show: true,
                      position: 'bottom',
                      labels: {
                        colors: '#74788d',
                      },
                    },

                    plotOptions: {
                      pie: {
                        donut: {
                          size: '2%',
                        },
                      },
                    },
                  }"
                ></apexchart>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="col-lg-6 col-sm-6">
        <div class="card h-100">
          <div class="card-body text-left">
            <div class="row">
              <div class="col-sm-6">
                <h5>{{ $t("twitter.twitter-view.tweets") }}</h5>
              </div>
              <div class="col-sm-6 text-right">
                <span
                  class="text-secondary btn btn-sm btn-light mr-1"
                  v-if="created_at_source"
                  >{{ $t("twitter.updated") }}
                  {{ formatDateRefresh(created_at_source) }}</span
                >
              </div>
            </div>
            <div class="col-sm-12 p-5 mt-5" v-if="loadingsource">
              <div class="text-center loading">
                <b-spinner label="Loading..."></b-spinner>
              </div>
            </div>
            <div
              class="col-sm-12 p-5 mt-5"
              v-if="!loadingsource && !label_source[0]"
            >
              <div class="text-center loading">
                {{ $t("all.dnf") }}
              </div>
            </div>
            <div
              class="col-sm-12 mt-5 pt-5 mb-3"
              v-if="!loadingsource && label_source[0]"
            >
              <apexchart
                class="apex-charts pt-2"
                dir="ltr"
                height="340"
                :series="sourceOptions.series"
                :options="{
                  chart: {
                    type: 'pie',
                    height: 340,
                    size: 250,
                  },
                  labels: label_source,
                  colors: [
                    '#7f1d1d',
                    '#961010',
                    '#a80a0a',
                    '#bc0505',
                    '#d10404',
                    '#ea1919',
                    '#f42c2c',
                    '#f94040',
                  ],
                  legend: {
                    show: true,
                    position: 'bottom',
                    labels: {
                      colors: '#74788d',
                    },
                  },

                  plotOptions: {
                    pie: {
                      donut: {
                        size: '2%',
                      },
                    },
                  },
                }"
              ></apexchart>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<script>
import Layout from "../../../layouts/main";
import appConfig from "@/app.config";
import PageHeader from "@/components/page-header";
import VueWordCloud from "vuewordcloud";
import TwintService from "@/helpers/twint.service";
import PreferenceService from "@/helpers/preference.service.js";
import SosmedService from "@/helpers/socmed.service";
import moment from "moment";
import { gmapApi } from "vue2-google-maps";

import { ref } from "vue";

/**
 * Profile component
 */
export default {
  page: {
    title: "Twitter View",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: { Layout, PageHeader, VueWordCloud },
  data() {
    let sentimenOptions = {
      series: [],
    };

    let sourceOptions = {
      series: [],
    };

    return {
      backUrl: "/twitter",
      items: [
        {
          text: "Dashboard",
          href: "/",
        },
        {
          text: "Twitter",
          href: "/twitter",
        },
        {
          text: this.$t("twitter.twitter-view.twitter-view"),
          active: true,
        },
      ],
      id: this.$route.params.id,
      theme: localStorage.getItem("theme"),
      cek_heatmap: false,
      loadingupdate: false,
      loadingsentiment: false,
      loadingsource: false,
      loadingtopmention: false,
      loadingheatmap: false,
      loadingtopfollowing: false,
      loadingtopfollowers: false,
      loadingtimeline: false,
      loadingworldcloud: false,
      loadinghastag: false,
      label_sentiment: [],
      label_source: [],
      colors_sentiment: [],
      sentimenOptions,
      sourceOptions,
      title: this.$t("twitter.twitter-view.person"),
      created_at_timeline: "",
      created_at_topmention: "",
      created_at_heatmap: "",
      created_at_wordcloud: "",
      created_at_hastagcloud: "",
      created_at_sentiment: "",
      created_at_source: "",
      elastic: "",
      fetchedData: null,
      tophastag: [],
      wordcloud: [],
      source: [],
      heatmap: [],
      sentiment: [],
      timeline: [],
      tableData: [],
      topFollowing: [],
      topFollowers: [],
      topMention: [],
      tableDataTopHastag: [],
      tableDataTopWordCloud: [],
      totalRows: 1,
      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100],
      filter: null,
      filterOn: [],
      sortBy: "age",
      sortDesc: false,
      basicInfo: {
        id: "",
        name: "",
        username: "",
        bio: "",
        location: "",
        followers: "",
        following: "",
        tweets: "",
        likes: "",
        favorites: "",
        media: "",
        join_date: "",
        join_time: "",
        private: "",
        verified: "",
        avatar: "",
        updated_at: "",
      },
      fieldsTimeline: [
        { key: "id", thClass: "d-none", tdClass: "d-none" },
        { key: "link", thClass: "d-none", tdClass: "d-none" },
        {
          key: "date",
          sortable: true,
          thStyle: { width: "10%" },
          label: this.$t("twitter.table.date"),
        },
        { key: "tweets", sortable: true, label: this.$t("twitter.table.post") },
        {
          key: "likes",
          class: "text-center",
          sortable: true,
          thStyle: { width: "7%" },
          label: this.$t("twitter.table.like"),
        },
        {
          key: "retweet",
          class: "text-center",
          sortable: true,
          thStyle: { width: "7%" },
          label: this.$t("twitter.table.retweets"),
        },
        {
          key: "actions",
          class: "text-center",
          label: this.$t("twitter.table.action"),
        },
      ],
      fieldsTopMention: [
        {
          key: "user_mention",
          sortable: true,
          label: this.$t("twitter.table.mention"),
        },
        {
          key: "count",
          sortable: true,
          class: "text-center",
          label: this.$t("twitter.table.total"),
        },
        {
          key: "percentage",
          sortable: true,
          class: "text-center",
          label: this.$t("twitter.table.percentage"),
        },
      ],
      fieldsTopFollowers: [
        { key: "id", thClass: "d-none", tdClass: "d-none" },
        { key: "url", thClass: "d-none", tdClass: "d-none" },
        { key: "username", thClass: "d-none", tdClass: "d-none" },
        { key: "profile_image_url_https", thClass: "d-none", tdClass: "d-none" },
        {
          key: "name",
          sortable: true,
          label: this.$t("twitter.table.account"),
        },
        {
          key: "followers",
          sortable: true,
          class: "text-center",
          label: this.$t("twitter.table.followers"),
        },
        {
          key: "following",
          sortable: true,
          class: "text-center",
          label: this.$t("twitter.table.following"),
        },
        {
          key: "tweets",
          sortable: true,
          class: "text-center",
          label: this.$t("twitter.table.post"),
        },
      ],
      fieldsTopFollowing: [
        { key: "id", thClass: "d-none", tdClass: "d-none" },
        { key: "url", thClass: "d-none", tdClass: "d-none" },
        { key: "username", thClass: "d-none", tdClass: "d-none" },
        { key: "profile_image_url_https", thClass: "d-none", tdClass: "d-none" },
        {
          key: "name",
          sortable: true,
          label: this.$t("twitter.table.account"),
        },
        {
          key: "followers",
          sortable: true,
          class: "text-center",
          label: this.$t("twitter.table.followers"),
        },
        {
          key: "following",
          sortable: true,
          class: "text-center",
          label: this.$t("twitter.table.following"),
        },
        {
          key: "tweets",
          sortable: true,
          class: "text-center",
          label: this.$t("twitter.table.post"),
        },
      ],
      fieldsTopHastag: [
        { key: "avatar", thClass: "d-none", tdClass: "d-none" },
        {
          key: "account",
          sortable: true,
          label: this.$t("twitter.table.account"),
        },
        {
          key: "followers",
          sortable: true,
          label: this.$t("twitter.table.followers"),
        },
        {
          key: "following",
          sortable: true,
          label: this.$t("twitter.table.following"),
        },
        { key: "post", sortable: true, label: this.$t("twitter.table.post") },
      ],
      fieldsTopWordCloud: [
        {
          key: "wordCloud",
          sortable: true,
          label: this.$t("twitter.table.word-cloud"),
        },
        {
          key: "total",
          sortable: true,
          class: "text-center",
          label: this.$t("twitter.table.total"),
        },
        {
          key: "percentage",
          sortable: true,
          class: "text-center",
          label: this.$t("twitter.table.percentage"),
        },
      ],
      fieldsTopHastag: [
        {
          key: "hastag",
          sortable: true,
          label: this.$t("twitter.table.hastag"),
        },
        {
          key: "total",
          sortable: true,
          class: "text-center",
          label: this.$t("twitter.table.total"),
        },
        {
          key: "percentage",
          sortable: true,
          class: "text-center",
          label: this.$t("twitter.table.percentage"),
        },
      ],
      wordCloud: [],
      hastagsCloud: [],
      heatmapSeries: [
        {
          name: "Sunday",
          data: [
            { x: "00:00", y: 0 },
            { x: "01:00", y: 0 },
            { x: "02:00", y: 0 },
            { x: "03:00", y: 0 },
            { x: "04:00", y: 0 },
            { x: "05:00", y: 0 },
            { x: "06:00", y: 0 },
            { x: "07:00", y: 0 },
            { x: "08:00", y: 0 },
            { x: "09:00", y: 0 },
            { x: "10:00", y: 0 },
            { x: "11:00", y: 0 },
            { x: "12:00", y: 0 },
            { x: "13:00", y: 0 },
            { x: "14:00", y: 0 },
            { x: "15:00", y: 0 },
            { x: "16:00", y: 0 },
            { x: "17:00", y: 0 },
            { x: "18:00", y: 0 },
            { x: "19:00", y: 0 },
            { x: "20:00", y: 0 },
            { x: "21:00", y: 0 },
            { x: "22:00", y: 0 },
            { x: "23:00", y: 0 },
            { x: "24:00", y: 0 },
          ],
        },
        {
          name: "Monday",
          data: [
            { x: "00:00", y: 0 },
            { x: "01:00", y: 0 },
            { x: "02:00", y: 0 },
            { x: "03:00", y: 0 },
            { x: "04:00", y: 0 },
            { x: "05:00", y: 0 },
            { x: "06:00", y: 0 },
            { x: "07:00", y: 0 },
            { x: "08:00", y: 0 },
            { x: "09:00", y: 0 },
            { x: "10:00", y: 0 },
            { x: "11:00", y: 0 },
            { x: "12:00", y: 0 },
            { x: "13:00", y: 0 },
            { x: "14:00", y: 0 },
            { x: "15:00", y: 0 },
            { x: "16:00", y: 0 },
            { x: "17:00", y: 0 },
            { x: "18:00", y: 0 },
            { x: "19:00", y: 0 },
            { x: "20:00", y: 0 },
            { x: "21:00", y: 0 },
            { x: "22:00", y: 0 },
            { x: "23:00", y: 0 },
            { x: "24:00", y: 0 },
          ],
        },
        {
          name: "Tuesday",
          data: [
            { x: "00:00", y: 0 },
            { x: "01:00", y: 0 },
            { x: "02:00", y: 0 },
            { x: "03:00", y: 0 },
            { x: "04:00", y: 0 },
            { x: "05:00", y: 0 },
            { x: "06:00", y: 0 },
            { x: "07:00", y: 0 },
            { x: "08:00", y: 0 },
            { x: "09:00", y: 0 },
            { x: "10:00", y: 0 },
            { x: "11:00", y: 0 },
            { x: "12:00", y: 0 },
            { x: "13:00", y: 0 },
            { x: "14:00", y: 0 },
            { x: "15:00", y: 0 },
            { x: "16:00", y: 0 },
            { x: "17:00", y: 0 },
            { x: "18:00", y: 0 },
            { x: "19:00", y: 0 },
            { x: "20:00", y: 0 },
            { x: "21:00", y: 0 },
            { x: "22:00", y: 0 },
            { x: "23:00", y: 0 },
            { x: "24:00", y: 0 },
          ],
        },
        {
          name: "Wednesday",
          data: [
            { x: "00:00", y: 0 },
            { x: "01:00", y: 0 },
            { x: "02:00", y: 0 },
            { x: "03:00", y: 0 },
            { x: "04:00", y: 0 },
            { x: "05:00", y: 0 },
            { x: "06:00", y: 0 },
            { x: "07:00", y: 0 },
            { x: "08:00", y: 0 },
            { x: "09:00", y: 0 },
            { x: "10:00", y: 0 },
            { x: "11:00", y: 0 },
            { x: "12:00", y: 0 },
            { x: "13:00", y: 0 },
            { x: "14:00", y: 0 },
            { x: "15:00", y: 0 },
            { x: "16:00", y: 0 },
            { x: "17:00", y: 0 },
            { x: "18:00", y: 0 },
            { x: "19:00", y: 0 },
            { x: "20:00", y: 0 },
            { x: "21:00", y: 0 },
            { x: "22:00", y: 0 },
            { x: "23:00", y: 0 },
            { x: "24:00", y: 0 },
          ],
        },
        {
          name: "Thursday",
          data: [
            { x: "00:00", y: 0 },
            { x: "01:00", y: 0 },
            { x: "02:00", y: 0 },
            { x: "03:00", y: 0 },
            { x: "04:00", y: 0 },
            { x: "05:00", y: 0 },
            { x: "06:00", y: 0 },
            { x: "07:00", y: 0 },
            { x: "08:00", y: 0 },
            { x: "09:00", y: 0 },
            { x: "10:00", y: 0 },
            { x: "11:00", y: 0 },
            { x: "12:00", y: 0 },
            { x: "13:00", y: 0 },
            { x: "14:00", y: 0 },
            { x: "15:00", y: 0 },
            { x: "16:00", y: 0 },
            { x: "17:00", y: 0 },
            { x: "18:00", y: 0 },
            { x: "19:00", y: 0 },
            { x: "20:00", y: 0 },
            { x: "21:00", y: 0 },
            { x: "22:00", y: 0 },
            { x: "23:00", y: 0 },
            { x: "24:00", y: 0 },
          ],
        },
        {
          name: "Friday",
          data: [
            { x: "00:00", y: 0 },
            { x: "01:00", y: 0 },
            { x: "02:00", y: 0 },
            { x: "03:00", y: 0 },
            { x: "04:00", y: 0 },
            { x: "05:00", y: 0 },
            { x: "06:00", y: 0 },
            { x: "07:00", y: 0 },
            { x: "08:00", y: 0 },
            { x: "09:00", y: 0 },
            { x: "10:00", y: 0 },
            { x: "11:00", y: 0 },
            { x: "12:00", y: 0 },
            { x: "13:00", y: 0 },
            { x: "14:00", y: 0 },
            { x: "15:00", y: 0 },
            { x: "16:00", y: 0 },
            { x: "17:00", y: 0 },
            { x: "18:00", y: 0 },
            { x: "19:00", y: 0 },
            { x: "20:00", y: 0 },
            { x: "21:00", y: 0 },
            { x: "22:00", y: 0 },
            { x: "23:00", y: 0 },
            { x: "24:00", y: 0 },
          ],
        },
        {
          name: "Saturday",
          data: [
            { x: "00:00", y: 0 },
            { x: "01:00", y: 0 },
            { x: "02:00", y: 0 },
            { x: "03:00", y: 0 },
            { x: "04:00", y: 0 },
            { x: "05:00", y: 0 },
            { x: "06:00", y: 0 },
            { x: "07:00", y: 0 },
            { x: "08:00", y: 0 },
            { x: "09:00", y: 0 },
            { x: "10:00", y: 0 },
            { x: "11:00", y: 0 },
            { x: "12:00", y: 0 },
            { x: "13:00", y: 0 },
            { x: "14:00", y: 0 },
            { x: "15:00", y: 0 },
            { x: "16:00", y: 0 },
            { x: "17:00", y: 0 },
            { x: "18:00", y: 0 },
            { x: "19:00", y: 0 },
            { x: "20:00", y: 0 },
            { x: "21:00", y: 0 },
            { x: "22:00", y: 0 },
            { x: "23:00", y: 0 },
            { x: "24:00", y: 0 },
          ],
        },
      ],
      location_coor: [],
      geocoder: null,
      center: { lat: parseFloat(-6.2), lng: parseFloat(106.816666) },
      zoom: 5,
      openedMarkerID: null,
    };
  },
  computed: {
    rows() {
      return this.tableData.length;
    },
    google: gmapApi,
  },
  methods: {
    getUserBasicInfo() {
      SosmedService.detailTwitter(this.id)
        .then((response) => {
          this.basicInfo.id = response.data.data.user_id;
          this.basicInfo.name = response.data.data.name;
          this.basicInfo.username = response.data.data.account;
          this.basicInfo.bio = response.data.data.bio;
          this.basicInfo.location = response.data.data.location;
          this.basicInfo.followers = response.data.data.followers;
          this.basicInfo.following = response.data.data.following;
          this.basicInfo.tweets = response.data.data.tweets;
          this.basicInfo.likes = response.data.data.likes;
          this.basicInfo.favorites = response.data.data.favorites;
          this.basicInfo.media = response.data.data.media;
          this.basicInfo.join_date = response.data.data.join_at;
          this.basicInfo.private = response.data.data.is_private;
          this.basicInfo.verified = response.data.data.is_verified;
          this.basicInfo.avatar = response.data.data.avatar;
          this.basicInfo.updated_at = response.data.data.updated_at;
          console.log('basic Info ', this.basicInfo);
        })
        .catch((err) => {
          // console.log('basic err ->',err);
        });
    },

    getPreferences() {
      PreferenceService.getAllElastic()
        .then((response) => {
          this.elastic = response.data.data[0].ip_address;
          this.getMention();
          this.getUserTimeline();
          this.getTopFollow();
          this.getHeatMap();
          this.getSentimentAnalys();
          this.getSource();
          this.getWordCloud();
          this.getHastagsCloud();
          // this.getTopFollowers();
        })
        .catch((err) => {
          // console.log(err);
        });
    },

    fetchData() {
      let data = {
        username: this.id
      };
      this.loadingtopmention = true;
      this.loadingtimeline = true;
      this.loadingsource = true;
      this.loadinghastag = true;
      this.loadingheatmap = true;
      TwintService.getTimelinev2Twint(data)
        .then((response) => {
          // Menyesuaikan dengan struktur response API baru
          this.fetchedData = {
            output: {
              timelines: response.data.data.timelines || [],
              mentions: response.data.data.mentions || [],
              hashtags: response.data.data.hashtags || []
            }
          };
          this.getMentionTwint();
          this.loadingtopmention = false;
          this.getUserTimelineTwint();
          this.loadingtimeline = false;
          this.getHeatMapTwint();
          this.loadingheatmap = false;
          this.getSourceTwint();
          this.loadingsource = false;
          this.getHastagsCloudTwint();
          this.loadinghastag = false;
        })
        .catch((err) => {
          console.log('Timeline API Error:', err);
          this.loadingtopmention = false;
          this.loadingtimeline = false;
          this.loadingheatmap = false;
          this.loadingsource = false;
          this.loadinghastag = false;
        });
    },

    updateTwitterAccount() {
      this.loadingupdate = true;
      let data = {
        args: this.id,
      };
      TwintService.getUser(data)
        .then((response) => {
          var dataTwitter = response.data.output;
          this.addNewTwitterData(dataTwitter);
          // console.log(dataTwitter);
          this.loadingupdate = false;
        })
        .catch((err) => {
          // console.log(err);
          this.loadingupdate = false;
        });
    },

    addNewTwitterData(dataTwitter) {
      var today = new Date();
      var time = today.toLocaleString("en-US", { timeZone: "Asia/Jakarta" });
      var dataSave = {
        // "id_target" : this.basicInfo.id,
        account: dataTwitter.screen_name,
        user_id: dataTwitter.user_id,
        name: dataTwitter.name,
        avatar: dataTwitter.avatar,
        followers: dataTwitter.followers,
        following: dataTwitter.following,
        tweets: dataTwitter.tweets,
        favorites: dataTwitter.favorites,
        likes: "0",
        media: "0",
        location: dataTwitter.location,
        bio: dataTwitter.bio,
        is_private: dataTwitter.private,
        is_verified: dataTwitter.verified,
        join_at: dataTwitter.created_at,
        updated_at: time,
      };
      // console.log(dataSave);
      SosmedService.createTwitter(dataSave)
        .then((response) => {
          // console.log(response)
          this.getUserBasicInfo();
        })
        .catch((err) => {
          // console.log(err);
        });
    },

    updateAll() {
      this.fetchData()
      this.updateTwitterAccount();
      this.getTopFollowingTwint();
      this.getTopFollowersTwint();
      this.getSentimentAnalysTwint();
      this.getWordCloudTwint();
    },
    // timeline
    getUserTimeline() {
      this.loadingtimeline = true;
      TwintService.getTimelineElastic(this.elastic, this.id)
        .then((response) => {
          this.tableData = response.data._source.timeline;
          this.created_at_timeline = response.data._source.created_at;
          this.loadingtimeline = false;
        })
        .catch((err) => {
          if (err == "Error: Request failed with status code 404") {
            this.getUserTimelineTwint();
          } else {
            // console.log(err);
            this.loadingtimeline = false;
          }
        })
        .finally(() => {
          this.geocodedAddress();
        });
    },

    getUserTimelineTwint() {
      this.loadingtimeline = true;
      if (!this.fetchedData || !this.fetchedData.output || !this.fetchedData.output.timelines) {
        this.loadingtimeline = true;
      } else {
        this.loadingtimeline = false;
        this.tableData = this.fetchedData.output.timelines;
        this.createUserTimeline();
        this.createUserTimelinev2();
      }
    },
    createUserTimeline() {
      var timeline = this.tableData;
      var today = new Date();
      var time = today.toLocaleString("en-US", { timeZone: "Asia/Jakarta" });
      const data = {
        created_at: time,
        username: this.id,
        timeline: timeline,
      };
      TwintService.createTimelineElastic(this.elastic, this.id, data)
        .then((response) => {
          // console.log('create timeline',response);
          this.created_at_timeline = time;
          this.loadingtimeline = false;
        })
        .catch((err) => {
          // console.log('timeline err ->',err);
          this.loadingtimeline = false;
        });
    },
    createUserTimelinev2() {
      var timeline = this.tableData;
      var today = new Date();
      var time = today.toLocaleString("en-US", { timeZone: "Asia/Jakarta" });
      const data = {
        created_at: time,
        username: this.id,
        timeline: timeline,
      };
      console.log('data send');
      console.log(data);
      TwintService.createTimelinev2backend(data)
        .then((response) => {
          console.log('create timeline backend',response);
          this.created_at_timeline = time;
          this.loadingtimeline = false;
        })
        .catch((err) => {
          console.log('timeline err ->',err);
          this.loadingtimeline = false;
        });
    },
    // top mention
    getMention() {
      this.loadingtopmention = true;
      TwintService.getMentionsElastic(this.elastic, this.id)
        .then((response) => {
          this.topMention = response.data._source.topmention;
          this.created_at_topmention = response.data._source.created_at;
          this.loadingtopmention = false;
        })
        .catch((err) => {
          if (err == "Error: Request failed with status code 404") {
            this.getMentionTwint();
          } else {
            // console.log(err);
            this.loadingtopmention = false;
          }
        });
    },

    getMentionTwint() {
      if (!this.fetchedData || !this.fetchedData.output || !this.fetchedData.output.mentions) {
        this.loadingtopmention = true;
      } else {
        this.loadingtopmention = false;
        this.topMention = this.fetchedData.output.mentions;
        this.createUserMention();
      }
    },
    // getMentionTwint() {
      // this.loadingtopmention = true;
      // const data = {
      //   id: this.basicInfo.id,
      //   nama: this.id,
      // };
      // this.topMention = this.fetchedData["output"]["mentions"];
      // this.createUserMention();
      // if (fetchedData != null) {
      //   this.topMention = this.fetchedData["output"]["mentions"];
      //   this.createUserMention();
      //   this.loadingtopmention = false;
      // } else {
      //   this.loadingtopmention = false;
      // }
      // TwintService.getMentionsTwint(data)
      //   .then((response) => {
      //     this.topMention = response.data.output;
      //     this.createUserMention();
      //   })
      //   .catch((err) => {
      //     // console.log('mention err ->', err);
      //     this.loadingtopmention = false;
      //   });
    // },

    createUserMention() {
      var topmention = this.topMention;
      var today = new Date();
      var time = today.toLocaleString("en-US", { timeZone: "Asia/Jakarta" });
      const data = {
        created_at: time,
        username: this.id,
        topmention: topmention,
      };
      TwintService.createMentionsElastic(this.elastic, this.id, data)
        .then((response) => {
          this.created_at_topmention = time;
          // console.log('create mention',response);
          this.loadingtopmention = false;
        })
        .catch((err) => {
          // console.log('timeline err ->',err);
          this.loadingtopmention = false;
        });
    },

    // followers following
    getTopFollow() {
      this.loadingtopfollowing = true;
      this.loadingtopfollowers = true;
      TwintService.getFollowElastic(this.elastic, this.id)
        .then((response) => {
          this.topFollowers = response.data._source.followers;
          this.topFollowing = response.data._source.following;

          this.loadingtopfollowing = false;
          this.loadingtopfollowers = false;
        })
        .catch((err) => {
          if (err == "Error: Request failed with status code 404") {
            this.getTopFollowingTwint();
            this.getTopFollowersTwint();
          } else {
            // console.log(err);
            this.loadingtopfollowing = false;
            this.loadingtopfollowers = false;
          }
        });
    },

    getTopFollowingTwint() {
      this.loadingtopfollowing = true;
      const data = {
        nama: this.id,
      };
      TwintService.getTopFollowing(data)
        .then((response) => {
          // Menyesuaikan dengan struktur response API baru
          this.topFollowing = response.data.data.users || [];
          this.createUserFollow();
        })
        .catch((err) => {
          console.log('top following err ->', err);
          this.loadingtopfollowing = false;
        });
    },

    getTopFollowersTwint() {
      this.loadingtopfollowers = true;
      const data = {
        nama: this.id,
      };
      TwintService.getTopFollowers(data)
        .then((response) => {
          // Menyesuaikan dengan struktur response API baru
          this.topFollowers = response.data.data.users || [];
          this.createUserFollow();
        })
        .catch((err) => {
          console.log('top follower err ->', err);
          this.loadingtopfollowing = false;
          this.loadingtopfollowers = false;
        });
    },
    createUserFollow() {
      var followers = this.topFollowers;
      var following = this.topFollowing;
      var today = new Date();
      var time = today.toLocaleString("en-US", { timeZone: "Asia/Jakarta" });
      const data = {
        created_at: time,
        username: this.id,
        following: following,
        followers: followers,
      };
      TwintService.createFollowElastic(this.elastic, this.id, data)
        .then((response) => {
          // console.log('create followers',response);
          this.loadingtopfollowing = false;
          this.loadingtopfollowers = false;
        })
        .catch((err) => {
          // console.log('timeline err ->',err);
          this.loadingtopfollowing = false;
          this.loadingtopfollowers = false;
        });
    },

    //heatmap
    getHeatMap() {
      (this.loadingheatmap = true),
        TwintService.getHeatMapElastic(this.elastic, this.id)
          .then((response) => {
            this.created_at_heatmap = response.data._source.created_at;
            response.data._source.heatmap.forEach((element) => {
              this.cek_heatmap = true;
              this.heatmapSeries.forEach((series) => {
                if (element.day == series.name) {
                  series.data.forEach((d) => {
                    if (d.x == element.hour + ":00") {
                      d.y = element.count;
                    }
                  });
                  // series.data.push({x: element.hour+':00', y:element.count})
                }
              });
            });
            this.loadingheatmap = false;
          })
          .catch((err) => {
            if (err == "Error: Request failed with status code 404") {
              this.getHeatMapTwint();
            } else {
              // console.log(err);
            }
          });
    },

    getHeatMapTwint() {
      this.loadingheatmap = true;
      const data = {
        nama: this.id,
        id: this.id
      };
      // console.log(data);
      TwintService.getHeatMap(data)
        .then((response) => {
          // Menyesuaikan dengan struktur response API baru
          this.heatmap = response.data.data.heatmap || [];
          this.heatmapSeries = [
            {
              name: "Sunday",
              data: [
                { x: "00:00", y: 0 },
                { x: "01:00", y: 0 },
                { x: "03:00", y: 0 },
                { x: "04:00", y: 0 },
                { x: "05:00", y: 0 },
                { x: "06:00", y: 0 },
                { x: "07:00", y: 0 },
                { x: "08:00", y: 0 },
                { x: "09:00", y: 0 },
                { x: "10:00", y: 0 },
                { x: "11:00", y: 0 },
                { x: "12:00", y: 0 },
                { x: "13:00", y: 0 },
                { x: "14:00", y: 0 },
                { x: "15:00", y: 0 },
                { x: "16:00", y: 0 },
                { x: "17:00", y: 0 },
                { x: "18:00", y: 0 },
                { x: "19:00", y: 0 },
                { x: "20:00", y: 0 },
                { x: "21:00", y: 0 },
                { x: "22:00", y: 0 },
                { x: "23:00", y: 0 },
                { x: "24:00", y: 0 },
              ],
            },
            {
              name: "Monday",
              data: [
                { x: "00:00", y: 0 },
                { x: "01:00", y: 0 },
                { x: "03:00", y: 0 },
                { x: "04:00", y: 0 },
                { x: "05:00", y: 0 },
                { x: "06:00", y: 0 },
                { x: "07:00", y: 0 },
                { x: "08:00", y: 0 },
                { x: "09:00", y: 0 },
                { x: "10:00", y: 0 },
                { x: "11:00", y: 0 },
                { x: "12:00", y: 0 },
                { x: "13:00", y: 0 },
                { x: "14:00", y: 0 },
                { x: "15:00", y: 0 },
                { x: "16:00", y: 0 },
                { x: "17:00", y: 0 },
                { x: "18:00", y: 0 },
                { x: "19:00", y: 0 },
                { x: "20:00", y: 0 },
                { x: "21:00", y: 0 },
                { x: "22:00", y: 0 },
                { x: "23:00", y: 0 },
                { x: "24:00", y: 0 },
              ],
            },
            {
              name: "Tuesday",
              data: [
                { x: "00:00", y: 0 },
                { x: "01:00", y: 0 },
                { x: "03:00", y: 0 },
                { x: "04:00", y: 0 },
                { x: "05:00", y: 0 },
                { x: "06:00", y: 0 },
                { x: "07:00", y: 0 },
                { x: "08:00", y: 0 },
                { x: "09:00", y: 0 },
                { x: "10:00", y: 0 },
                { x: "11:00", y: 0 },
                { x: "12:00", y: 0 },
                { x: "13:00", y: 0 },
                { x: "14:00", y: 0 },
                { x: "15:00", y: 0 },
                { x: "16:00", y: 0 },
                { x: "17:00", y: 0 },
                { x: "18:00", y: 0 },
                { x: "19:00", y: 0 },
                { x: "20:00", y: 0 },
                { x: "21:00", y: 0 },
                { x: "22:00", y: 0 },
                { x: "23:00", y: 0 },
                { x: "24:00", y: 0 },
              ],
            },
            {
              name: "Wednesday",
              data: [
                { x: "00:00", y: 0 },
                { x: "01:00", y: 0 },
                { x: "03:00", y: 0 },
                { x: "04:00", y: 0 },
                { x: "05:00", y: 0 },
                { x: "06:00", y: 0 },
                { x: "07:00", y: 0 },
                { x: "08:00", y: 0 },
                { x: "09:00", y: 0 },
                { x: "10:00", y: 0 },
                { x: "11:00", y: 0 },
                { x: "12:00", y: 0 },
                { x: "13:00", y: 0 },
                { x: "14:00", y: 0 },
                { x: "15:00", y: 0 },
                { x: "16:00", y: 0 },
                { x: "17:00", y: 0 },
                { x: "18:00", y: 0 },
                { x: "19:00", y: 0 },
                { x: "20:00", y: 0 },
                { x: "21:00", y: 0 },
                { x: "22:00", y: 0 },
                { x: "23:00", y: 0 },
                { x: "24:00", y: 0 },
              ],
            },
            {
              name: "Thursday",
              data: [
                { x: "00:00", y: 0 },
                { x: "01:00", y: 0 },
                { x: "03:00", y: 0 },
                { x: "04:00", y: 0 },
                { x: "05:00", y: 0 },
                { x: "06:00", y: 0 },
                { x: "07:00", y: 0 },
                { x: "08:00", y: 0 },
                { x: "09:00", y: 0 },
                { x: "10:00", y: 0 },
                { x: "11:00", y: 0 },
                { x: "12:00", y: 0 },
                { x: "13:00", y: 0 },
                { x: "14:00", y: 0 },
                { x: "15:00", y: 0 },
                { x: "16:00", y: 0 },
                { x: "17:00", y: 0 },
                { x: "18:00", y: 0 },
                { x: "19:00", y: 0 },
                { x: "20:00", y: 0 },
                { x: "21:00", y: 0 },
                { x: "22:00", y: 0 },
                { x: "23:00", y: 0 },
                { x: "24:00", y: 0 },
              ],
            },
            {
              name: "Friday",
              data: [
                { x: "00:00", y: 0 },
                { x: "01:00", y: 0 },
                { x: "03:00", y: 0 },
                { x: "04:00", y: 0 },
                { x: "05:00", y: 0 },
                { x: "06:00", y: 0 },
                { x: "07:00", y: 0 },
                { x: "08:00", y: 0 },
                { x: "09:00", y: 0 },
                { x: "10:00", y: 0 },
                { x: "11:00", y: 0 },
                { x: "12:00", y: 0 },
                { x: "13:00", y: 0 },
                { x: "14:00", y: 0 },
                { x: "15:00", y: 0 },
                { x: "16:00", y: 0 },
                { x: "17:00", y: 0 },
                { x: "18:00", y: 0 },
                { x: "19:00", y: 0 },
                { x: "20:00", y: 0 },
                { x: "21:00", y: 0 },
                { x: "22:00", y: 0 },
                { x: "23:00", y: 0 },
                { x: "24:00", y: 0 },
              ],
            },
            {
              name: "Saturday",
              data: [
                { x: "00:00", y: 0 },
                { x: "01:00", y: 0 },
                { x: "03:00", y: 0 },
                { x: "04:00", y: 0 },
                { x: "05:00", y: 0 },
                { x: "06:00", y: 0 },
                { x: "07:00", y: 0 },
                { x: "08:00", y: 0 },
                { x: "09:00", y: 0 },
                { x: "10:00", y: 0 },
                { x: "11:00", y: 0 },
                { x: "12:00", y: 0 },
                { x: "13:00", y: 0 },
                { x: "14:00", y: 0 },
                { x: "15:00", y: 0 },
                { x: "16:00", y: 0 },
                { x: "17:00", y: 0 },
                { x: "18:00", y: 0 },
                { x: "19:00", y: 0 },
                { x: "20:00", y: 0 },
                { x: "21:00", y: 0 },
                { x: "22:00", y: 0 },
                { x: "23:00", y: 0 },
                { x: "24:00", y: 0 },
              ],
            },
          ];
          this.createUserHeatmap();
          this.cek_heatmap = true;
          // Mapping day numbers to day names
          const dayNames = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
          response.data.data.heatmap.forEach((element) => {
            this.heatmapSeries.forEach((series) => {
              // Convert day number to day name for comparison
              const dayName = dayNames[element.day];
              if (dayName == series.name) {
                series.data.forEach((d) => {
                  if (d.x == element.hour + ":00") {
                    d.y = element.count;
                  }
                });
              }
            });
          });
        })

        .catch((err) => {
          // console.log('heatmap err ->',err);
          this.loadingheatmap = false;
        });
    },

    createUserHeatmap() {
      var heatmap = this.heatmap;
      var today = new Date();
      var time = today.toLocaleString("en-US", { timeZone: "Asia/Jakarta" });
      const data = {
        created_at: time,
        username: this.id,
        heatmap: heatmap,
      };
      TwintService.createHeatMapElastic(this.elastic, this.id, data)
        .then((response) => {
          this.created_at_heatmap = time;
          this.loadingheatmap = false;
          // console.log('create heatmap',response);
        })
        .catch((err) => {
          // console.log('timeline err ->',err);
          this.loadingheatmap = false;
        });
    },

    // sentimen analys
    getSentimentAnalys() {
      this.loadingsentiment = true;
      TwintService.SentimentAnalysElastic(this.elastic, this.id)
        .then((response) => {
          this.created_at_sentiment = response.data._source.created_at;
          response.data._source.sentiment.forEach((event) => {
            this.label_sentiment.push(event.sentiment);
            this.colors_sentiment.push(event.color);
            this.sentimenOptions.series.push(event.count);
          });
          this.loadingsentiment = false;
        })
        .catch((err) => {
          if (err == "Error: Request failed with status code 404") {
            this.getSentimentAnalysTwint();
          } else {
            // console.log(err);
            this.loadingsentiment = false;
          }
        });
    },
    getSentimentAnalysTwint() {
      this.loadingsentiment = true;
      const data = {
        nama: this.id,
      };
      TwintService.SentimentAnalys(data)
        .then((response) => {
          // Menyesuaikan dengan struktur response API baru
          this.sentiment = response.data.data.sentiments || [];
          this.createUserSentiment();
          this.sentimenOptions.series = [];
          this.label_sentiment = [];
          this.colors_sentiment = [];
          response.data.data.sentiments.forEach((event) => {
            this.label_sentiment.push(event.sentiment);
            this.colors_sentiment.push(event.color);
            this.sentimenOptions.series.push(event.count);
            // console.log(event.count);
          });
        })
        .catch((err) => {
          // console.log('sentiment err ->',err);
          this.loadingsentiment = false;
        });
    },
    createUserSentiment() {
      var sentiment = this.sentiment;
      var today = new Date();
      var time = today.toLocaleString("en-US", { timeZone: "Asia/Jakarta" });
      const data = {
        created_at: time,
        username: this.id,
        sentiment: sentiment,
      };
      // console.log(this.sentiment);
      if (this.sentiment[0]) {
        TwintService.createUserSentimentElastic(this.elastic, this.id, data)
          .then((response) => {
            this.created_at_sentiment = time;
            this.getUserBasicInfo();
            this.loadingsentiment = false;
          })
          .catch((err) => {
            // console.log('timeline err ->',err);
            this.loadingsentiment = false;
          });
      } else {
        this.loadingsentiment = false;
      }
    },

    // source
    getSource() {
      this.loadingsource = true;
      TwintService.getSourceElastic(this.elastic, this.id)
        .then((response) => {
          this.created_at_source = response.data._source.created_at;
          response.data._source.source.forEach((event) => {
            this.label_source.push(event.source);
            this.sourceOptions.series.push(event.count);
          });

          this.loadingsource = false;
        })
        .catch((err) => {
          if (err == "Error: Request failed with status code 404") {
            this.getSourceTwint();
          } else {
            // console.log(err);
            this.loadingsource = false;
          }
        });
    },
    // getSourceTwint() {
    //   this.loadingsource = true;
    //   const data = {
    //     username: this.id,
    //   };
    //   TwintService.getSource(data)
    //     .then((response) => {
    //       this.source = response.data.output;
    //       this.createSourceElastic();
    //       this.sourceOptions.series = [];
    //       this.label_source = [];
    //       response.data.output.forEach((event) => {
    //         this.label_source.push(event.source);
    //         this.sourceOptions.series.push(event.count);
    //       });
    //     })
    //     .catch((err) => {
    //       // console.log('source err ->',err);
    //       this.loadingsource = false;
    //     });
    // },
    getSourceTwint() {
      this.loadingsource = true;
      const data = {
        nama: this.id,
      };
      TwintService.getSource(data)
        .then((response) => {
          // Menyesuaikan dengan struktur response API baru
          this.source = response.data.data.sources || [];
          this.createSourceElastic();
          this.sourceOptions.series = [];
          this.label_source = [];
          response.data.data.sources.forEach((event) => {
            console.log("Event Source:", event.source);
            console.log("Event Count:", event.count);
            this.label_source.push(event.source);
            this.sourceOptions.series.push(event.count);
          });
          this.loadingsource = false;
        })
        .catch((err) => {
          console.log('source err ->', err);
          this.loadingsource = false;
        });
    },
    createSourceElastic() {
      var source = this.source;
      var today = new Date();
      var time = today.toLocaleString("en-US", { timeZone: "Asia/Jakarta" });
      const data = {
        created_at: time,
        username: this.id,
        source: source,
      };
      TwintService.createUserSourceElastic(this.elastic, this.id, data)
        .then((response) => {
          this.created_at_source = time;
          this.loadingsource = false;
        })
        .catch((err) => {
          // console.log('timeline err ->',err);
          this.loadingsource = false;
        });
    },

    // wordcloud
    getWordCloud() {
      this.loadingworldcloud = true;
      TwintService.getWordCloudElastic(this.elastic, this.id)
        .then((response) => {
          this.created_at_wordcloud = response.data._source.created_at;
          response.data._source.wordcloud.forEach((element, i) => {
            this.wordCloud.push([element.word, element.count]);
            if (i <= 9) {
              this.tableDataTopWordCloud.push({
                wordCloud: element.word,
                total: element.count,
                percentage: parseFloat(element.percentage).toFixed(0) + "%",
              });
            }
          });
          this.loadingworldcloud = false;
        })
        .catch((err) => {
          if (err == "Error: Request failed with status code 404") {
            this.getWordCloudTwint();
          } else {
            // console.log(err);
            this.loadingworldcloud = false;
          }
        });
    },
    getWordCloudTwint() {
      this.loadingworldcloud = true;
      const data = {
        nama: this.id,
      };
      TwintService.getWordCloud(data)
        .then((response) => {
          // Menyesuaikan dengan struktur response API baru
          this.wordcloud = response.data.data.words || [];
          this.createWordCloudElastic();
          response.data.data.words.forEach((element, i) => {
            this.wordCloud.push([element.word, element.count]);
            if (i <= 9) {
              this.tableDataTopWordCloud.push({
                wordCloud: element.word,
                total: element.count,
                percentage: parseFloat(element.percentage).toFixed(0) + "%",
              });
            }
          });
          this.loadingworldcloud = false;
        })
        .catch((err) => {
          // console.log('word cloud err ->',err);
          this.loadingworldcloud = false;
        });
    },
    createWordCloudElastic() {
      var wordcloud = this.wordcloud;
      var today = new Date();
      var time = today.toLocaleString("en-US", { timeZone: "Asia/Jakarta" });
      const data = {
        created_at: time,
        username: this.id,
        wordcloud: wordcloud,
      };
      TwintService.createUserWordCloudElastic(this.elastic, this.id, data)
        .then((response) => {
          this.created_at_wordcloud = time;
          this.loadingworldcloud = false;
          // console.log('create word cloud',response);
        })
        .catch((err) => {
          // console.log('timeline err ->',err);
          this.loadingworldcloud = false;
        });
    },

    // hastag
    getHastagsCloud() {
      this.loadinghastag = true;
      TwintService.getHastagsElastic(this.elastic, this.id)
        .then((response) => {
          this.created_at_hastagcloud = response.data._source.created_at;
          response.data._source.tophastag.forEach((element) => {
            this.hastagsCloud.push([element.hashtags, element.count]);
            this.tableDataTopHastag.push({
              hastag: element.hashtags,
              total: element.count,
              percentage: parseFloat(element.percentage).toFixed(0) + "%",
            });
          });
          this.loadinghastag = false;
        })
        .catch((err) => {
          if (err == "Error: Request failed with status code 404") {
            this.getHastagsCloudTwint();
          } else {
            // console.log(err);
            this.loadinghastag = false;
          }
        });
    },
    // getHastagsCloudTwint() {
    //   this.loadinghastag = true;
    //   const data = {
    //     username: this.id,
    //   };
    //   TwintService.getHastagsCloud(data)
    //     .then((response) => {
    //       this.tophastag = response.data.output;
    //       this.createHastagsCloudElastic();
    //       response.data.output.forEach((element) => {
    //         this.hastagsCloud.push([element.hashtags, element.count]);
    //         this.tableDataTopHastag.push({
    //           hastag: element.hashtags,
    //           total: element.count,
    //           percentage: parseFloat(element.percentage).toFixed(0) + "%",
    //         });
    //       });
    //     })
    //     .catch((err) => {
    //       // console.log('hastags err -> ',err);
    //       this.loadinghastag = false;
    //     });
    // },
    getHastagsCloudTwint() {
      this.loadinghastag = true;
        if (!this.fetchedData || !this.fetchedData.output || !this.fetchedData.output.hashtags) {
          this.loadinghastag = true;
        } else {
          this.loadinghastag = false;
          this.tophastag = this.fetchedData.output.hashtags;
          this.createHastagsCloudElastic();
          this.fetchedData.output.hashtags.forEach((element) => {
            console.log("Event Source:", element.source);
            console.log("Event Count:", element.count);
            this.hastagsCloud.push([element.hashtags, element.count]);
            this.tableDataTopHastag.push({
              hastag: element.hashtags,
              total: element.count,
              percentage: parseFloat(element.percentage).toFixed(0) + "%",
            });
          });
        }
    },
    createHastagsCloudElastic() {
      var tophastag = this.tophastag;
      var today = new Date();
      var time = today.toLocaleString("en-US", { timeZone: "Asia/Jakarta" });
      const data = {
        created_at: time,
        username: this.id,
        tophastag: tophastag,
      };
      // console.log(data);
      TwintService.createUserHastagsElastic(this.elastic, this.id, data)
        .then((response) => {
          this.created_at_hastagcloud = time;
          this.loadinghastag = false;
          // console.log('create hastag',response);
        })
        .catch((err) => {
          // console.log('timeline err ->',err);
          this.loadinghastag = false;
        });
    },

    //map
    geocodedAddress() {
      this.$gmapApiPromiseLazy().then(() => {
        if (this.google) {
          this.geocoder = new this.google.maps.Geocoder();
        }
      });
      this.location_coor = [];
      this.tableData.forEach((element) => {
        if (Object.keys(element.place).length !== 0) {
          this.geocoder.geocode(
            { address: element.place.full_name },
            (results, status) => {
              this.location_coor.push({
                lat: results[0].geometry.location.lat(),
                long: results[0].geometry.location.lng(),
                content: element,
              });
            }
          );
        }
      });
    },
    openMarker(id) {
      this.openedMarkerID = id;
    },

    formatDate(value) {
      return moment(value).format("DD MMM YYYY, hh:mm");
    },
    formatDateRefresh(value) {
      return moment(value).format("YYYY-MM-DD, hh:mm");
    },
    formatDay(value) {
      return moment(value).format("dddd");
    },
    toFixed(value) {
      return value.toFixed(0);
    },
  },
  mounted() {
    this.theme = localStorage.getItem("theme");
    this.getPreferences();
    this.fetchData();
    this.totalRows = this.items.length;
    this.getUserBasicInfo();
    this.$gmapApiPromiseLazy().then(() => {
      if (this.google) {
        this.geocoder = new this.google.maps.Geocoder();
      }
    });
  },
};
</script>

<style scoped>
/* .card{
  border: 2px solid #f1f1f1;
} */
.my-custom-scrollbar {
  position: relative;
  height: 500px;
  overflow: auto;
}
.table-wrapper-scroll-y {
  display: block;
}
</style>
